// F4-10 SEPA-machtigingsaddendum.
//
// JURIDISCHE CONCEPTMODULE: de tekst in SEPA_MACHTIGING_TEMPLATE is een
// doorgesproken conceptversie, nog te laten checken door een boekhouder/
// jurist vóór productiegebruik met echte incasso's. Wijzig de bewoording
// niet zonder die controle opnieuw te laten uitvoeren.
//
// Wordt als één tekstblok behandeld (net als de bestaande algemene
// voorwaarden in OvereenkomstPage.jsx buildAgreementText()) — niet per
// zinsdeel via i18n-sleutels.
//
// Versie 2 (2026-07-09): pre-notificatietermijn 3 dagen, herincasso-
// clausule, elektronische-ondertekeningsclausule, machtigingskenmerk-
// verduidelijking.

export const SEPA_TEXT_VERSION = '2';

const SEPA_MACHTIGING_TEMPLATE = `SEPA-machtiging voor doorlopende incasso

Door deze overeenkomst te ondertekenen en het onderstaande vakje aan te vinken verleent u een doorlopende SEPA-machtiging aan Fit En Sterker.

Ondergetekende, {KLANT_NAAM}, wonende te {KLANT_ADRES}, houder van IBAN {KLANT_IBAN}, geeft hierbij toestemming aan Fit En Sterker, gevestigd te {PLAATS}, kantoorhoudende aan {BEDRIJFSADRES}, incassant-ID {INCASSANT_ID}, om doorlopende incasso-opdrachten naar zijn/haar bank te sturen om bedragen overeenkomstig deze overeenkomst van zijn/haar rekening af te schrijven. Tevens geeft ondergetekende toestemming aan zijn/haar bank om deze bedragen overeenkomstig de opdrachten van Fit En Sterker van zijn/haar rekening af te schrijven.

Voorafgaande kennisgeving (pre-notificatie): De incassant stuurt uiterlijk {TERMIJN_DAGEN} kalenderdagen vóór de incassodatum een kennisgeving per e-mail met het te incasseren bedrag en de geplande afschrijfdatum. U stemt ermee in dat deze verkorte termijn van {TERMIJN_DAGEN} kalenderdagen (in plaats van de standaardtermijn van 14 dagen) van toepassing is op alle incasso's onder deze machtiging.

Herincasso bij mislukte afschrijving: Indien een incasso niet kan worden uitgevoerd (bijvoorbeeld door onvoldoende saldo of een technische storing), mag de incassant onder hetzelfde mandaat een herincassopoging doen zonder dat daarvoor een nieuwe machtiging nodig is. U wordt voorafgaand aan de herincasso per e-mail geïnformeerd over het bedrag en de nieuwe geplande incassodatum.

Machtigingskenmerk: Dit kenmerk wordt na ondertekening door Fit En Sterker toegekend. Het machtigingskenmerk wordt vermeld op de eerste voorafgaande kennisgeving (factuur) en op uw bankafschrift.
Type incasso: Doorlopend (Recurring)
Datum machtiging: {ONDERTEKENDATUM}

Elektronische ondertekening: Deze machtiging wordt elektronisch ondertekend. Als bewijs van toestemming worden vastgelegd: datum en tijdstip van ondertekening, het IP-adres van de ondertekenaar, de gebruikte accountgegevens, en de op dat moment geldende machtigingstekst (versie {SEPA_TEXT_VERSION}).

Indien u het niet eens bent met een afschrijving, kunt u deze binnen 8 weken na afschrijving zonder opgave van reden laten terugboeken via uw bank. Voor de voorwaarden kunt u contact opnemen met uw bank.

Deze machtiging maakt integraal onderdeel uit van deze overeenkomst en blijft geldig totdat zij door de klant wordt ingetrokken of de overeenkomst eindigt.`;

/**
 * Vult de SEPA-machtigingstekst in. Ontbrekende gegevens worden als
 * duidelijke placeholder gerenderd i.p.v. te crashen.
 *
 * @param {object} params
 * @param {string} params.klantNaam
 * @param {string} [params.klantAdres] - woonplaats van de klant (profiles.city); placeholder als leeg.
 * @param {string} params.klantIban - alleen gebruikt voor eenmalige weergave in dit document, nooit los opgeslagen.
 * @param {string} params.plaats
 * @param {string} params.bedrijfsadres
 * @param {string} [params.incassantId] - settings.mollie_incassant_id; placeholder als leeg.
 * @param {string} params.ondertekendatum - bv. toLocaleDateString('nl-NL', ...)
 * @param {number|string} params.termijnDagen - settings.company_payment_term_days.
 */
export function buildSepaMachtigingText({
  klantNaam,
  klantAdres,
  klantIban,
  plaats,
  bedrijfsadres,
  incassantId,
  ondertekendatum,
  termijnDagen,
}) {
  return SEPA_MACHTIGING_TEMPLATE
    .replace(/\{KLANT_NAAM\}/g, klantNaam || '[naam onbekend]')
    .replace(/\{KLANT_ADRES\}/g, (klantAdres || '').trim() || '[adres niet bekend]')
    .replace(/\{KLANT_IBAN\}/g, klantIban || '[iban onbekend]')
    .replace(/\{PLAATS\}/g, plaats || '[plaats onbekend]')
    .replace(/\{BEDRIJFSADRES\}/g, bedrijfsadres || '[bedrijfsadres onbekend]')
    .replace(/\{INCASSANT_ID\}/g, (incassantId || '').trim() || '[nog niet beschikbaar]')
    .replace(/\{ONDERTEKENDATUM\}/g, ondertekendatum || '[datum onbekend]')
    .replace(/\{TERMIJN_DAGEN\}/g, String(termijnDagen ?? '3'))
    .replace(/\{SEPA_TEXT_VERSION\}/g, SEPA_TEXT_VERSION);
}
